// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import './assets/js/common.js'
import httpRequest from './assets/js/request'
Vue.prototype.$http = httpRequest
import apiList from './assets/js/api.js'
Vue.prototype.apiList = apiList
import 'vant/lib/index.css';
import {
  Toast,
  Popup
} from 'vant';

Vue.use(Toast).use(Popup);

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js